import axios from 'axios'

// * VENUE MANAGER API
// Config this axios intance to reiceive the base URL bellow
const venueManagerApi = axios.create({
	baseURL: process.env.REACT_APP_VENUE_MANAGER_BASE_URL,
})

// * USER MANAGER API
const userManagerApi = axios.create({
	baseURL: process.env.REACT_APP_USER_MANAGER_BASE_URL,
})

// * WAITLIST API
const waitlistApi = axios.create({
	baseURL: process.env.REACT_APP_WAITLIST_BASE_URL,
	headers: {
		apptoken: process.env.REACT_APP_APP_TOKEN,
	},
})

export { venueManagerApi, userManagerApi, waitlistApi }
